import * as React from 'react';

class CheckboxAgGridEditor extends React.Component{
  state = {
    checked: false,
  };

  componentDidMount() {
    this.setState({checked: this.props.value})
  }

  getValue = () => {
    return this.state.checked;
  };

  onChange = (e) => {
    const {agGridReact,node,column} = this.props;
    const {currentValuesChanges} = agGridReact.props;
    let data = node.data;

    data[column.colId] = e.target.value === 'true';
    currentValuesChanges(data);
    this.setState({checked: e.target.value === 'true'})
  };

  render(){
    return(
      <select value={this.state.checked} onChange={e => this.onChange(e)}>
        <option value="true">true</option>
        <option value="false">false</option>
      </select>
    )
  }
}
export default CheckboxAgGridEditor;


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/FieldRenderer/CheckboxAgGridEditor.js